<template>
	<div
		class="p-4 w-64 flex flex-col bg-white rounded-lg"
		id="stats"
		role="tabpanel"
		aria-labelledby="stats-tab">
		<div class="flex-grow flex items-center justify-between mb-4">
			<h5
				class="pr-4 text-xl font-bold leading-normal text-gray-900 dark:text-white">
				{{ subject }}
			</h5>
			<a
				target="_blank"
				:href="paper"
				class="inline-flex items-center px-2 py-2 rounded-full transform rotate-90 text-sm font-medium text-center text-white bg-blue-700 hover:bg-blue-800">
				<svg
					aria-hidden="true"
					class="w-5 h-5"
					fill="currentColor"
					viewBox="0 0 20 20"
					xmlns="http://www.w3.org/2000/svg">
					<path
						fill-rule="evenodd"
						d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
						clip-rule="evenodd"></path>
				</svg>
			</a>
		</div>
		<div>
			<hr class="mx-1 my-2 bg-gray-700" />
			<dl class="flex justify-between mx-auto text-gray-900">
				<div class="flex flex-col items-center justify-center">
					<dt class="mb-1 text-sm">{{ semester }}</dt>
					<dd class="font-medium text-gray-500">SEM</dd>
				</div>
				<div class="flex flex-col items-center justify-center">
					<dt class="mb-1 text-sm">{{ year }}</dt>
					<dd class="font-medium text-gray-500">Year</dd>
				</div>
				<div class="flex flex-col items-center justify-center">
					<dt class="mb-1 text-sm">{{ branch }}</dt>
					<dd class="font-medium text-gray-500">Branch</dd>
				</div>
			</dl>
		</div>
		<div
			:class="profilePage ? '' : 'hidden'"
			class="flex justify-between mt-4 space-x-3 md:mt-6">
			<div>
				<button
					v-on:click="toggleModal()"
					class="inline-flex items-center px-6 py-2 text-sm font-medium text-center text-gray-800 border border-gray-800 rounded-lg hover:border-gray-500 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
					Edit
				</button>
				<div
					v-if="showModal"
					v-on:click="toggleModal()"
					class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
					<div class="relative my-6 mx-auto max-w-6xl">
						<!--content-->
						<div
							@click.stop="() => {}"
							class="px-8 py-8 w-80 border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
							<!--header-->
							<div
								class="pb-4 flex items-center justify-between border-b border-solid border-slate-200 rounded-t">
								<h3 class="text-xl font-semibold">Add Paper</h3>
								<button
									class="ml-auto bg-transparent border-0 text-black text-xl leading-none font-semibold outline-none focus:outline-none"
									v-on:click="toggleModal()">
									<span
										class="bg-transparent block outline-none focus:outline-none">
										X
									</span>
								</button>
							</div>
							<!--body-->
							<form
								class="space-y-4"
								@submit.prevent="handleSubmit()">
								<input
									v-model="subject"
									class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
									type="text"
									autocomplete="on"
									placeholder="Subject" />
								<div class="flex flex-col justify-center">
									<h3 class="mb-1 font-semibold text-gray-900 dark:text-white">
										Select Branch
									</h3>
									<select
										v-model="branch"
										class="form-select appearance-none block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none"
										aria-label="Branches">
										<option
											value="Computer"
											selected>
											Computer
										</option>
										<option value="IT">IT</option>
										<option value="EXTC">EXTC</option>
										<option value="Other">Other</option>
									</select>
								</div>
								<div class="px-2">
									<h3 class="mb-1 font-semibold text-gray-900 dark:text-white">
										Select Semester
									</h3>
									<div class="flex flex-col w-full justify-center">
										<div class="flex justify-between items-center">
											<div class="flex items-center mr-4">
												<input
													id="1st"
													type="radio"
													v-model="semester"
													value="1st"
													name="colored-radio"
													class="w-4 h-4 bg-gray-100 border-gray-300" />
												<label
													for="1st"
													class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
													1st
												</label>
											</div>
											<div class="flex items-center mr-4">
												<input
													id="2nd"
													type="radio"
													v-model="semester"
													value="2nd"
													name="colored-radio"
													class="w-4 h-4 bg-gray-100 border-gray-300" />
												<label
													for="2nd"
													class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
													2nd
												</label>
											</div>
											<div class="flex items-center mr-4">
												<input
													checked
													id="3rd"
													type="radio"
													v-model="semester"
													value="3rd"
													name="colored-radio"
													class="w-4 h-4 bg-gray-100 border-gray-300" />
												<label
													for="3rd"
													class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
													3rd
												</label>
											</div>
											<div class="flex items-center">
												<input
													id="4th"
													type="radio"
													v-model="semester"
													value="4th"
													name="colored-radio"
													class="w-4 h-4 bg-gray-100 border-gray-300" />
												<label
													for="4th"
													class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
													4th
												</label>
											</div>
										</div>

										<div class="flex justify-between items-center">
											<div class="flex items-center mr-4">
												<input
													id="5th"
													type="radio"
													v-model="semester"
													value="5th"
													name="colored-radio"
													class="w-4 h-4 bg-gray-100 border-gray-300" />
												<label
													for="5th"
													class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
													5th
												</label>
											</div>
											<div class="flex items-center -ml-1 mr-4">
												<input
													id="6th"
													type="radio"
													v-model="semester"
													value="6th"
													name="colored-radio"
													class="w-4 h-4 bg-gray-100 border-gray-300" />
												<label
													for="6th"
													class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
													6th
												</label>
											</div>
											<div class="flex items-center mr-4">
												<input
													checked
													id="7th"
													type="radio"
													v-model="semester"
													value="7th"
													name="colored-radio"
													class="w-4 h-4 bg-gray-100 border-gray-300" />
												<label
													for="7th"
													class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
													7th
												</label>
											</div>
											<div class="flex items-center">
												<input
													id="8th"
													type="radio"
													v-model="semester"
													value="8th"
													name="colored-radio"
													class="w-4 h-4 bg-gray-100 border-gray-300" />
												<label
													for="8th"
													class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
													8th
												</label>
											</div>
										</div>
									</div>
								</div>
								<input
									v-model="paper"
									class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
									type="url"
									autocomplete="on"
									placeholder="Paper URL" />
								<div
									class="flex items-center justify-between border-t border-solid border-slate-200 rounded-b">
									<button
										class="text-purple-800 bg-transparent border border-solid border-purple-800 hover:bg-purple-800 hover:text-white active:bg-red-600 font-bold uppercase text-sm px-4 py-3 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
										type="button"
										v-on:click="toggleModal()">
										Close
									</button>
									<button
										type="submit"
										class="flex justify-center bg-purple-800 hover:bg-purple-700 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500">
										Submit
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
				<div
					v-if="showModal"
					class="opacity-25 fixed inset-0 z-40 bg-black"></div>
			</div>
			<span
				@click="handleDelete()"
				class="inline-flex items-center px-5 py-2 text-sm font-medium cursor-pointer text-center text-gray-900 bg-red-400 bg-opacity-80 rounded-lg hover:bg-opacity-75 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:ring-gray-700">
				Delete
			</span>
		</div>
	</div>
</template>
<script>
import axios from 'axios'

export default {
	name: 'PaperCard',
	data() {
		return {
			profilePage: false,
			showModal: false
		}
	},
	methods: {
		toggleModal: function () {
			this.showModal = !this.showModal
		},
		async handleSubmit() {
			const data = {
				subject: this.subject,
				branch: this.branch,
				semester: this.semester,
				year: Math.ceil(Number(this.semester.substring(0, 1)) / 2),
				paper: this.paper
			}
			const res = await axios.put(`api/paper/${this.id}`, data)
			this.toggleModal()
			alert(res.data.message)
		},
		async handleDelete() {
			const res = await axios.delete(`api/paper/${this.id}`)
			if (res.status == 204) alert('Item deleted successfully')
			this.$router.go()
		}
	},
	mounted() {
		if (this.$route.name == 'profile') this.profilePage = true
	},
	props: {
		paper: String,
		semester: String,
		branch: String,
		year: Number,
		subject: String,
		id: String
	}
}
</script>